import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton, Link } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router';
export const LinkWithArrow = ({ to, ariaLabel, ariaDescribedBy, children }) => (React.createElement(Link, { "aria-label": ariaLabel, "aria-describedby": ariaDescribedBy, component: RouterLink, to: to, underline: 'none', "data-test": 'link-with-arrow', sx: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flexDirection: 'row',
        color: themeColors.text.main,
        ':hover': {
            cursor: 'pointer',
            backgroundColor: themeColors.surface.hover,
        },
        ':focus-visible': {
            backgroundColor: themeColors.surface.hover,
            outline: 'none',
        },
    } },
    React.createElement(Box, { sx: {
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            gap: 2,
            p: 2,
            width: '100%',
        } }, children),
    React.createElement(Box, { p: 2 },
        React.createElement(IconButton, { sx: {
                p: 1,
                ':hover': {
                    backgroundColor: themeColors.accent.blue.alpha,
                },
            }, "aria-hidden": true, tabIndex: -1 },
            React.createElement(ChevronRightIcon, { color: 'primary' })))));
